export default {
  showGradient: false,
};
